module.exports = __webpack_public_path__ + "img/compact.49f2b2d4.png";